import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  content: {
    height: '400px',
    overflowY: 'auto',
    padding: '20px',
    '& > div': {
      height: '100%'
    }
  },
  table: {
    boxShadow: 'none'
  },
  cellContent: {
    borderRadius: '2px',
    display: 'flex',
    alignItems: 'center',
    padding: '5px 10px'
  },
  cellLeft: {
    width: '100%'
  },
  cellLongName: {
    display: 'block',
    overflow: 'hidden',
    textAlign: 'left',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  rightAlign: {
    textAlign: 'right'
  }
});
export default useStyles;